/* eslint-disable react/prefer-stateless-function */
import React, { PropTypes, Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { NitroIcon, NitroModal, NitroParagraph } from 'nitro-components';
import { media } from 'style-utils';
import styled from 'styled-components';

import Paper from 'material-ui/Paper';
import ActionsMenu from './ActionsMenu';

import AdminAPI from '../../api/AdminApi';

const MenuPopover = styled.div`
  position: absolute;
  width: fit-content;
  right: 72px;
  display: block;
  z-index: 1;
  opacity: 0;
  transform: scale(0);
  transition: transform 0s 0.3s, opacity 0.3s ease-out;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: 0.23px;
  font-size: 14px;
  font-family: ${props => props.theme.font.default};
  ${media.tablet`
    margin: -10px 16px;
    padding-top: 0;
  `}

  ${media.mobile`
    margin: 0;
    padding-top: 0;
    width: 100vw;
    z-index: 1501;
    top: -2px;
  `}

  ${props =>
    props.open &&
    `
      opacity: 1;
      transform: scale(1);
      transition: transform 0s, opacity .3s ease-out;
      pointer-events: all;
    `}
`;
const ActionButtonsContainer = styled.span`
  margin: 0 8px;
  & svg {
    transform: rotate(90deg);
  }
`;

const ModalContent = styled.div`
  width: 100%;
`;

class ActionButtons extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      showModal: false,
      action: ''
    };
  }

  toggle = e => {
    // Prevents ghost clicking on touch devices
    e.preventDefault();
    this.setState({ open: !this.state.open });
  };

  lock = () => {
    AdminAPI.bulkLock([this.props.rowData.userId])
      .then(res => {
        console.log(res);
        if (res.status == 200) {
          this.props.refresh(this.props.currentPage);
        }
        if (!this.props.edit) {
          this.context.router.push({
            pathname: '/usermanagement'
          });
        } else {
          this.setState({ showModal: false, open: false });
        }
      })
      .catch(err => console.log(err));
  };
  unlock = () => {
    AdminAPI.bulkUnlock([this.props.rowData.userId])
      .then(res => {
        if (res.status == 200) {
          this.props.refresh(this.props.currentPage);
        }
        if (!this.props.edit) {
          this.context.router.push({
            pathname: '/usermanagement'
          });
        } else {
          this.setState({ showModal: false, open: false });
        }
      })
      .catch(err => console.log(err));
  };
  terminate = () => {
    AdminAPI.bulkTerminate([this.props.rowData.userId])
      .then(res => {
        if (res.status == 200) {
          this.props.refresh(this.props.currentPage);
        }
        if (!this.props.edit) {
          this.context.router.push({
            pathname: '/usermanagement'
          });
        } else {
          this.setState({ showModal: false, open: false });
        }
      })
      .catch(err => console.log(err));
  };
  reactivate = () => {
    AdminAPI.bulkReactivate([this.props.rowData.userId])
      .then(res => {
        if (res.status == 200) {
          this.props.refresh(this.props.currentPage);
        }
        if (!this.props.edit) {
          this.context.router.push({
            pathname: '/usermanagement'
          });
        } else {
          this.setState({ showModal: false, open: false });
        }
      })
      .catch(err => console.log(err));
  };
  onMenuLinkClick = menuOption => {
    this.setState({ open: false });
    const userId = this.props.rowData.userId;

    if (menuOption.route) {
      this.context.router.push({
        pathname: `${menuOption.route}/${userId}`,
        state: { editMode: true }
      });
    } else if (menuOption.title) {
      switch (menuOption.title) {
        case 'Lock Account':
          this.setState({
            showModal: true,
            action: 'lock'
          });
          break;
        case 'Unlock Account':
          this.setState({
            showModal: true,
            action: 'unlock'
          });

          break;
        case 'Terminate':
          this.setState({
            showModal: true,
            action: 'terminate'
          });

          break;
        case 'Reactivate':
          this.setState({
            showModal: true,
            action: 'reactivate'
          });

          break;
        default:
          break;
      }
    }
  };
  actionMenu = (finalMenu, status) => {
    switch (status) {
      case 'Active':
        // active -- terminate, lock
        return finalMenu.filter(
          x => !['Unlock Account', 'Reactivate'].includes(x.title)
        );
      case 'Locked':
        // locked -- unlock, terminate
        return finalMenu.filter(
          x => !['Lock Account', 'Reactivate'].includes(x.title)
        );
      case 'Inactive':
        // inactive -- terminate, lock -- ???
        return finalMenu.filter(
          x => !['Unlock Account', 'Reactivate'].includes(x.title)
        );
      case 'Terminated':
        // terminated -- reactivate
        return finalMenu.filter(
          x =>
            !['Unlock Account', 'Lock Account', 'Terminate'].includes(x.title)
        );

      default:
        return finalMenu;
    }
  };
  render() {
    const { finalMenu } = this.props;
    const { status } = this.props.rowData;
    const menuLinks = this.actionMenu(finalMenu, status).filter(e => {
      if (this.props.edit) {
        return !['Edit', 'Clone', 'Reset Password'].includes(e.title);
      }
      return true;
    });
    return (
      <ActionButtonsContainer
        onClick={e => {
          this.toggle(e);
          e.stopPropagation();
        }}
      >
        <NitroIcon name="overflow" variant="secondary" size={14} right={12} />
        <MenuPopover open={this.state.open}>
          <Paper>
            <ActionsMenu
              menus={menuLinks}
              onMenuLinkClick={this.onMenuLinkClick}
            />
          </Paper>
        </MenuPopover>
        <NitroModal
          title={`Confirm ${this.state.action} user `}
          action={() => this[this.state.action]()}
          actionLabel="Confirm"
          cancelAction={() => this.setState({ showModal: false })}
          cancelLabel="Discard"
          isOpen={this.state.showModal}
          close={() => this.setState({ showModal: false })}
          messageFlexDirection="row"
        >
          <ModalContent>
            <NitroParagraph align="center">
              Are you sure you want to {this.state.action}{' '}
              {this.props.rowData.userName}?
            </NitroParagraph>

            <NitroParagraph align="center" />
          </ModalContent>
        </NitroModal>
      </ActionButtonsContainer>
    );
  }
}
ActionButtons.contextTypes = {
  router: PropTypes.shape({})
};

ActionButtons.propTypes = {
  finalMenu: PropTypes.array
};

ActionButtons.defaultProps = {
  finalMenu: [
    {
      title: 'Edit',
      route: '/usermanagement/user'
    },
    // {
    //   title: 'Clone',
    //   url: '/usermanagement/userlisting'
    // },
    {
      title: 'Reset Password',
      route: '/usermanagement/user'
    },
    {
      title: 'Lock Account',
      url: '/usermanagement'
    },
    {
      title: 'Unlock Account',
      url: '/usermanagement'
    },
    {
      title: 'Terminate',
      url: '/usermanagement/userlisting'
    },
    {
      title: 'Reactivate',
      url: '/usermanagement/userlisting'
    }
  ]
};

export default ActionButtons;



// WEBPACK FOOTER //
// ./src/features/userManagement/ActionButtons.js